import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const PRODUCTS = [
  { kicker: "Skill game machines", title: "Fortune skill game cabinet", price: "$3,500 all in", href: "/fortune", tid: "place-fortune",
    body: "A 43-inch skill game machine for c-stores, gas stations and bars with a 6-game pack included — newest game Fortune Treasures. Free delivery & install on 2+ cabinets, 1-year parts & labor, no revenue share." },
  { kicker: "Sweepstakes game kiosk", title: "AOG Sweeps game kiosk", price: "Free for the store", href: "/aog-coin", tid: "place-aog",
    body: "A sweepstakes game platform with a free sign-up kiosk for the counter. Nothing to buy, nothing to install yourself. 21+, no purchase necessary, eligible states only." },
  { kicker: "ATM kiosk", title: "ATM kiosk", price: "$6,000 each", href: "/fortune#atm", tid: "place-atm",
    body: "Flat price at any quantity, installed on site about 5 days after the order, sold in any state. Pairs with the game machines by the register." },
];

// Homepage: the machines Arcade Ops places — keyword-rich, static (prerendered) copy with links into the product pages.
export default function PlacementProductsSection() {
  return (
    <section id="what-we-place" className="border-t border-border/60 scroll-mt-20" data-testid="placement-products">
      <div className="max-w-7xl mx-auto px-4 py-14 sm:py-16">
        <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-neon-cyan">What we place</div>
        <h2 className="mt-2 font-heading font-black text-base md:text-lg text-white max-w-3xl">
          Skill game machines, pre-reveal games, sweepstakes game kiosks and ATM kiosks — gaming machines for c-stores, gas stations, bars and laundromats, placed by route operators or bought outright by the store.
        </h2>
        <div className="mt-8 grid md:grid-cols-3 gap-4">
          {PRODUCTS.map((p) => (
            <Link key={p.href} to={p.href} data-testid={p.tid} className="group border border-border/70 bg-black/30 p-5 hover:border-neon-yellow/70 transition-colors">
              <div className="font-mono text-[10px] uppercase tracking-widest text-white/55">{p.kicker}</div>
              <div className="mt-2 flex items-baseline justify-between gap-3">
                <h3 className="font-heading font-bold text-foreground group-hover:text-neon-yellow transition-colors">{p.title}</h3>
                <span className="font-mono text-[11px] text-neon-yellow whitespace-nowrap">{p.price}</span>
              </div>
              <p className="mt-2 text-sm text-white/65 leading-relaxed">{p.body}</p>
              <div className="mt-4 inline-flex items-center gap-1 font-mono text-[10px] uppercase tracking-widest text-neon-cyan group-hover:text-neon-yellow">Learn more <ArrowRight className="w-3 h-3" /></div>
            </Link>
          ))}
        </div>
        <p className="mt-6 text-sm text-white/55">
          New to the category? Start with <Link to="/blog/skill-games-for-convenience-stores-how-placement-works" className="text-neon-cyan hover:text-white">how skill game placement works</Link> or <Link to="/blog/what-is-a-pre-reveal-game" className="text-neon-cyan hover:text-white">what a pre-reveal game is</Link>. Machines are sold for use where permitted by law.
        </p>
      </div>
    </section>
  );
}
